import React from 'react';
import ReactDOM from 'react-dom';
import SearchBox from './searchBox';

export default function initSearchBox () {
  if ($('#search-box').length > 0) {
    var searchEndpoint = $('#search-box').data('search-endpoint');

    ReactDOM.render(
      <SearchBox searchEndpoint={ searchEndpoint } />,
      document.getElementById('search-box')
    );
  }
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/index.jsx